// Module
var code = "<div class=\"hint_root\" perfect-scrollbar wheel-propagation=\"false\"> <div render-html-data template=\"{{vm.renderTemplate()}}\"></div> </div> ";
// Exports
module.exports = code;